import { useReducer } from 'react';

import { IAction } from 'src/utils/ts-utilities';

enum ActionEnum {
  REMOVE_MEMBERSHIP = 'remove-membership',
  SET_REMOVE_DIALOG_CLOSED = 'set-remove-dialog-closed',
  EDIT_MEMBERSHIP = 'edit-membership',
  SET_EDIT_DIALOG_CLOSED = 'set-edit-dialog-closed',
}

type IActionReducer =
  | IAction<ActionEnum.REMOVE_MEMBERSHIP, string>
  | IAction<ActionEnum.SET_REMOVE_DIALOG_CLOSED>
  | IAction<ActionEnum.EDIT_MEMBERSHIP, string>
  | IAction<ActionEnum.SET_EDIT_DIALOG_CLOSED>;

export type IState = {
  removeMembershipId: string | null;
  editMembershipId: string | null;
};

const initialState: IState = {
  removeMembershipId: null,
  editMembershipId: null,
};

const reducer = (state: IState, action: IActionReducer): IState => {
  switch (action.type) {
    case ActionEnum.REMOVE_MEMBERSHIP:
      return {
        ...state,
        removeMembershipId: action.payload,
      };
    case ActionEnum.SET_REMOVE_DIALOG_CLOSED:
      return {
        ...state,
        removeMembershipId: null,
      };
    case ActionEnum.EDIT_MEMBERSHIP:
      return {
        ...state,
        editMembershipId: action.payload,
      };
    case ActionEnum.SET_EDIT_DIALOG_CLOSED:
      return {
        ...state,
        editMembershipId: null,
      };
    default:
      return state;
  }
};

export const useMembershipActionsSlice = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const openRemoveDialog = (id: string) => dispatch({ type: ActionEnum.REMOVE_MEMBERSHIP, payload: id });
  const closeRemoveDialog = () => dispatch({ type: ActionEnum.SET_REMOVE_DIALOG_CLOSED, payload: {} });
  const openEditDialog = (id: string) => dispatch({ type: ActionEnum.EDIT_MEMBERSHIP, payload: id });
  const closeEditDialog = () => dispatch({ type: ActionEnum.SET_EDIT_DIALOG_CLOSED, payload: {} });

  return {
    ...state,
    openRemoveDialog,
    closeRemoveDialog,
    openEditDialog,
    closeEditDialog,
  };
};
